import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CustomFieldModel} from "../../../site-preferences/models/custom-field.model";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";

export class FulfillmentViewSettingsPanelComponent implements IController {

  settings: any;
  isLinesView: boolean;
  onSettingsChange: Function;

  public packageCustomFields: CustomFieldModel[] = [];

  /* @ngInject */
  constructor(private $mdPanel, private splitService) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = this.settings;
    const isLinesViewRef = this.isLinesView;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<fulfillment-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings" is-lines-view="ctrl.isLinesView"></fulfillment-settings-panel-template>',
      controller: function() {
        this.settings = settingsRef;
        this.isLinesView = isLinesViewRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess:(panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    const settingsConfig = this.splitService.getSiteFulfillmentSettings(this.splitService.getSiteId());
    this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentViewSettingsPanel', {
    bindings: {
      settings: '<',
      isLinesView: '<',
      onSettingsChange: '&'
    },
    template: require('./fulfillment-view-settings-panel.html').default,
    controller: FulfillmentViewSettingsPanelComponent
  });
